"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable camelcase */
var BasicPageTitle = function PageTitleComponent(_ref) {
  var dataClient = _ref.dataClient,
      sliceData = _ref.sliceData;
  var _sliceData$primary = sliceData.primary,
      page_title = _sliceData$primary.page_title,
      title_alignment = _sliceData$primary.title_alignment;
  var pageTitleClassName = (0, _classnames["default"])('content-page__title', {
    'content-page__title--left-align': title_alignment === 'Left',
    'content-page__title--center-align': title_alignment === 'Center',
    'content-page__title--right-align': title_alignment === 'Right'
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: pageTitleClassName
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: "content-page__title-text"
  }, dataClient.textToMarkdown(page_title))));
};
/* eslint-disable camelcase */


BasicPageTitle.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  sliceData: _propTypes["default"].shape({
    primary: _propTypes["default"].shape({
      page_title: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired
    }).isRequired
  }).isRequired
};
var _default = BasicPageTitle;
exports["default"] = _default;